import * as SentryVue from "@sentry/vue";
import { App } from "vue";
import { Router } from "vue-router";
import release from "./release.js";

const project = window.location.host; // distinguish local events from prod events - see releases page: https://spikedatacoza.sentry.io/releases/?project=4504887809277952

export function init(app: App<Element>, router?: Router) {
  // https://docs.sentry.io/platforms/javascript/performance/instrumentation/automatic-instrumentation/
  // only necessary in order to link transactions together as part of a single trace when tracing both frontend and backend via sentry
  // probably not necessary if only tracing frontend?
  const tracePropagationTargets = ["localhost", "app.local.spikedata.co.za", "app2.spikedata.co.za", /^\//];

  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/integrations/vue-router/
  let browserTracing;
  if (router) {
    browserTracing = new SentryVue.BrowserTracing({
      routingInstrumentation: SentryVue.vueRouterInstrumentation(router),
      tracePropagationTargets,
    });
  } else {
    browserTracing = new SentryVue.BrowserTracing({
      tracePropagationTargets,
    });
  }

  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/
  SentryVue.init({
    app,
    // ilancopelyn@gmail.com
    // dsn: "https://5852b904f5d645f1ae062682127ec170@o4504888283627520.ingest.sentry.io/4504888284807168",
    // ilan@spikedata.co.za
    dsn: "https://6cb854665cc0430ea64a28e18b94a823@o1361625.ingest.sentry.io/4504887809277952",
    integrations: [browserTracing],
    tracesSampleRate: 1.0,
    release: `${project}:${release}`,
  });
}

export function setUser(email: string) {
  // console.log("setUser:", email);
  // https://docs.sentry.io/platforms/javascript/guides/vue/enriching-events/identify-user/
  SentryVue.setUser({ email: email || "unknown" });
  // SentryVue.captureMessage("another test"); // TODO:remove
}
